<template>
  <div class="pdf-frame">
    <iframe :src="`/pdfjs/web/viewer.html?file=${pdfUrl}`"></iframe>
  </div>
</template>

<script>
export default {
  name: 'PdfViewer',
  props: {
    pdfUrl: String
  }
}
</script>

<style scoped>
.pdf-frame {
  width: 100%;
  height: calc(100vh - 64px - 80px);
}

.pdf-frame iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
